const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/", "/privacy"],
    exact: true,
    component: "Privacy",
  },
  {
    path: ["/", "/nani"],
    exact: true,
    component: "Nani",
  },
  {
    path: ["/", "/terms"],
    exact: true,
    component: "Terms",
  },
];

export default routes;
